import { styled } from '@material-ui/core';

export const Wrapper = styled('div')(({ theme: { breakpoints } }) => ({
  [breakpoints.up('sm')]: {
    position: 'relative',
    minHeight: '100vh',
  },
}));
